export const PRISMIC_CUSTOM_TYPE = Object.freeze({
    AIRPORT_MIDFUNNEL: 'consumer-page-airport',
    CITY_MIDFUNNEL: 'consumer-page-city',
    CONFIRMATION: 'consumer-single-confirmation',
    DESTINATION_MIDFUNNEL: 'consumer-page-destination',
    EVENT_PACKAGE_VENUE: 'consumer-single-event-package-venue',
    HOME_PAGE: 'home-page',
    LEGAL: 'consumer-page-legal',
    MARKETING_PAGES: 'default-marketing-pages',
});

export const PRISMIC_SPAN_LINK_TYPE = Object.freeze({
    DOCUMENT: 'Document',
    MEDIA: 'Media',
    WEB: 'Web',
});

export const PRISMIC_SPAN_TYPE = Object.freeze({
    HYPERLINK: 'hyperlink',
});
